import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { WhiteContainer } from '../Login/styledComponents';
import { CustomButton, CustomInput, Text } from '../../shared/uiComponents';
import { errorNormalizer, validateEmail } from '../../shared/Helpers/functions';
import { DispatchProperties, useSelector } from '../../redux/store';
import { forgetPassword } from '../../redux/State/identitySlice/accountSlice';
import { Logo } from '../../components/Logo';

export const RecoveryPasswordContent = () => {
	const [params] = useSearchParams();
	const loading = useSelector((state) => state.account.loading);

	const dispatch = useDispatch<DispatchProperties>();

	const [email, setEmail] = useState<string>(params.get('email') ?? '');
	const [emailError, setEmailError] = useState<string>('');

	useEffect(() => {
		if (Boolean(email) && !validateEmail(email)) {
			setEmailError('Invalid email');
		}
	}, [email]);

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		dispatch(forgetPassword(email))
			.then(unwrapResult)
			.then(() => toast('Your recovery link is sent'))
			.catch(errorNormalizer);
	};

	const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value);
		setEmailError('');
	};

	return (
		<WhiteContainer>
			<Text title="Recover password" type="h4" font="header" fontWeight="semiBold" className="marginBottom24" />

			<form onSubmit={handleSubmit}>
				<CustomInput
					value={email}
					onChange={onEmailChange}
					label="Email"
					className="marginBottom16"
					type="email"
					error={Boolean(emailError)}
					errorMessage={emailError}
				/>

				<CustomButton title="Send email" type="submit" loading={loading} disabled={Boolean(emailError)} />
			</form>

			<Logo />
		</WhiteContainer>
	);
};
